export const THEME = {
  BASE: 'base',
  IONOS: 'ionos',
  SDS: 'sds',
  BECHTLE: 'bechtle',
  ITZBUND: 'itzbund',
};
